// extracted by mini-css-extract-plugin
export default {"propertyInfo":"styles_propertyInfo__IziWL","photo":"styles_photo__lJpnG","info":"styles_info__Hp8Qn","address":"styles_address__Pq6Kw","metaInfo":"styles_metaInfo__ZhSsC"};